module.exports = __webpack_public_path__ + "static/media/33.c9887c65.mp3";